import styled from 'styled-components';

export const TableLinkMLStyled = styled.div`
  .name {
    color: ${(props) => props.theme[props.brand].btn.bgColor};
    cursor: pointer;
  }
`;
